@if (interactive()) {
  <button
    class="cta-badge"
    [ngClass]="[color(), size(), shape(), isIconOnly() ? 'icon-only' : '']"
    [class.highlighted]="highlighted()"
    [class.bordered]="bordered()"
    [class.disabled]="disabled()"
    [attr.aria-label]="ariaLabel() ?? text()"
    [disabled]="disabled()"
    (click)="onClick()"
  >
    @if (icon()) {
      <ptl-icon (click)="onIconClick()" (keydown)="onIconClick()" [icon]="icon()" [size]="'xs'"></ptl-icon>
    }

    @if (text()) {
      <span class="button-text" [innerHTML]="text()"></span>
    }

    <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>

    @if (iconSuffix()) {
      <ptl-icon (click)="onIconClick()" (keydown)="onIconClick()" [icon]="iconSuffix()" [size]="'xs'"></ptl-icon>
    }
  </button>
} @else {
  <span
    class="cta-badge"
    [ngClass]="[color(), size(), shape(), isIconOnly() ? 'icon-only' : '']"
    [class.highlighted]="highlighted()"
    [class.bordered]="bordered()"
    [class.disabled]="disabled()"
  >
    @if (icon()) {
      <ptl-icon [icon]="icon()" [size]="'xs'"></ptl-icon>
    }

    @if (text()) {
      <span class="button-text" [innerHTML]="text()"></span>
    }

    <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>

    @if (iconSuffix()) {
      <ptl-icon [icon]="iconSuffix()" [size]="'xs'"></ptl-icon>
    }
  </span>
}

<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>
